import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Brand } from '../../../../core/models/brand';
import { DashboardReportingQueryTypes, IReportDateRange, ReportDao } from '../../../../core/services/dao/reportDao';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { DemoConstants } from '../../../../assets/data/demoConstants';

type KwQueryRecord = {
  sessionCount: number;
  keywordText: string;
  isMicroMoment: boolean;
  isci: string;
};

type KwMappingValue = {
  mm_count: number;
  outside_mm_count: number;
  creatives: Set<string>;
  keyword: string;
  percent_mm: number;
  total_sessions: number;
};

@Component({
  selector: 'kw-tile',
  templateUrl: './kw-tile.component.html',
  styleUrls: ['kw-tile.component.scss']
})
export class KwTileComponent implements OnInit, OnDestroy, AfterViewInit {
  dateRangeSubscription: Subscription;
  @Input() brand: Brand;
  @Input() timezone: string;
  @Input() creatives: Array<string>;
  public currentDateRange: IReportDateRange;
  private subs: any[] = [];
  public loadingData = true;
  private kwMapping: { [key: string]: KwMappingValue };
  public dataSource: MatTableDataSource<KwMappingValue>;
  public displayedColumns = ['keyword', 'mm_count', 'percent_mm', 'total_sessions'];
  public selectedCreative = 'All';
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  public records = DemoConstants.keywords;

  constructor() {}

  ngOnInit() {
    this.fetchTileData();
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  fetchTileData() {
    this.initKeywordMapping(this.records);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.loadingData = false;
  }

  getPercentTotal(record: KwMappingValue): number {
    if (record.mm_count) {
      let num = (record.mm_count / (record.mm_count + record.outside_mm_count)) * 100;
      return +num.toFixed(2);
    } else {
      return 0;
    }
  }

  getCreatives(): string[] {
    return ['All'].concat(Array.from(this.creatives));
  }

  changeSelectedCreative(evt) {
    let records;
    if (this.selectedCreative === '' || this.selectedCreative === 'All') {
      records = this.records;
    } else {
      records = DemoConstants[this.selectedCreative];
    }
    this.initKeywordMapping(records);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.loadingData = false;
  }

  initKeywordMapping(records: any) {
    const kwMapping: { [key: string]: KwMappingValue } = {};
    for (const record of records) {
      if (record.keywordText && record.keywordText !== '') {
        this.updateKWMapping(record, kwMapping);
      }
    }
    for (let val of Object.values(kwMapping)) {
      val.percent_mm = this.getPercentTotal(val);
      val.total_sessions = val.mm_count + val.outside_mm_count;
    }
    this.kwMapping = kwMapping;
    this.dataSource = new MatTableDataSource<KwMappingValue>(Object.values(kwMapping));
  }

  updateKWMapping(record: KwQueryRecord, mapping: any) {
    let val: KwMappingValue;
    if (!mapping[record.keywordText]) {
      val = {
        mm_count: 0,
        outside_mm_count: 0,
        creatives: new Set<string>(),
        keyword: record.keywordText
      } as KwMappingValue;
    } else {
      val = mapping[record.keywordText];
    }
    if (record.isMicroMoment) {
      val.mm_count += record.sessionCount;
      val.creatives.add(record.isci);
    } else {
      val.outside_mm_count += record.sessionCount;
    }
    mapping[record.keywordText] = val;
  }

  ngOnDestroy() {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
